import styled from 'styled-components'

export const BirthSelectorContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	gap: 0.5rem;
`
